import React, { createContext, useCallback, useEffect, useState } from "react";
import { THEMES } from "../data/rates.js";

export const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem("t2290-theme") || "day";
    } catch {
      return "day";
    }
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try {
      localStorage.setItem("t2290-theme", theme);
    } catch {
      /* no-op */
    }
  }, [theme]);

  const cycleTheme = useCallback(() => {
    setTheme((cur) => {
      const i = THEMES.findIndex((t) => t[0] === cur);
      return THEMES[(i + 1) % THEMES.length][0];
    });
  }, []);

  const themeName = (THEMES.find((t) => t[0] === theme) || THEMES[0])[1];

  return (
    <ThemeContext.Provider value={{ theme, themeName, cycleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
